import {
  DEFAULT_CURRENCY,
  DEFAULT_FILTER,
} from "~/store/persistentAppSettings.redux";
import React, { memo } from "react";

import CrossChannelProductPerformanceWidget from "~/modules/widgets/overview/crossChannelProductPerformance/crossChannelProductPerformance";
import get from "lodash/get";
import { useDateRangeFilters } from "~/hooks/useDateRangeFilters";
import { useTranslation } from "react-i18next";
import { useTypedSelector } from "~/hooks/useTypedSelector";

const CrossChannelProductPerformance = memo(
  function CrossChannelProductPerformance() {
    const currentCurrency = useTypedSelector(
      (state) =>
        get(state, "persistentAppSettings.setting.data.currentCurrency") ||
        DEFAULT_CURRENCY
    );

    const includeTax = useTypedSelector((state) =>
      Boolean(state.persistentAppSettings?.setting?.data?.includeTax)
    );

    const { currentRange } = useDateRangeFilters();

    const currentFilter = useTypedSelector(
      (state) =>
        get(state, "persistentAppSettings.setting.data.currentFilter") ||
        DEFAULT_FILTER
    );

    const filteredStores = useTypedSelector((state) =>
      get(state, "mystore.filteredStores.stores", [])
    );

    return (
      <CrossChannelProductPerformanceWidget
        currentRange={currentRange}
        currentFilter={currentFilter}
        includeTax={includeTax}
        currentCurrency={currentCurrency}
        filteredStores={filteredStores}
      />
    );
  }
);

export default CrossChannelProductPerformance;
